function BackgroundImage(props) {
  return <img src={props.src} style={props.style} />;
}

export default BackgroundImage;
